// extracted by mini-css-extract-plugin
export default {"bodyRight":"ManageVariables_bodyRight__l3tsQ","bodyLeft":"ManageVariables_bodyLeft__Lqhty"};